import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-map',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnChanges {
  @Input() orderCoordinates: any = {};
  @ViewChild('mapElement', { static: false }) mapElement: ElementRef | undefined;

  center: google.maps.LatLngLiteral = { lat: 19.452608, lng: -99.123209 };
  zoom: number = 13;

  map: google.maps.Map | null = null;
  markers: { position: google.maps.LatLngLiteral; title: string; icon: string }[] = [];

  private markersOnMap: google.maps.Marker[] = [];

  mapInitialized = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderCoordinates'] && this.orderCoordinates) {
      this.updateMarkers();
      if (this.map) {
        this.removeMarkers();
        this.addMarkersToMap();
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.mapElement) {
      this.map = this.initMap(this.mapElement.nativeElement, this.center, this.zoom);
      this.addMarkersToMap();
    }
  }

  private updateMarkers(): void {
    if (
      this.orderCoordinates.finalLatitude &&
      this.orderCoordinates.finalLongitude &&
      this.orderCoordinates.latitude &&
      this.orderCoordinates.longitude
    ) {
      this.markers = [
        {
          position: {
            lat: parseFloat(this.orderCoordinates.finalLatitude),
            lng: parseFloat(this.orderCoordinates.finalLongitude),
          },
          title: 'Marcador 1',
          icon: 'assets/images/icon-map-tracking.svg',
        },
        {
          position: {
            lat: parseFloat(this.orderCoordinates.latitude),
            lng: parseFloat(this.orderCoordinates.longitude),
          },
          title: 'Marcador 2',
          icon: 'assets/images/icon-map-home.svg',
        },
      ];
    }
  }

  private addMarkersToMap(): void {
    if (this.map && this.markers.length > 0) {
      this.markers.forEach((markerData) => {
        const marker = this.addMarker(this.map!, markerData.position, markerData.icon);
        this.markersOnMap.push(marker);
      });

      if (!this.mapInitialized) {
        this.moveCameraToMarker(this.markers[0].position);
        this.mapInitialized = true;
      }
    } else {
      console.error('El mapa no está inicializado o no hay marcadores');
    }
  }

  initMap(mapElement: HTMLElement, center: google.maps.LatLngLiteral, zoom: number): google.maps.Map {
    return new google.maps.Map(mapElement, {
      center: center,
      zoom: zoom,
    });
  }

  addMarker(map: google.maps.Map, position: google.maps.LatLngLiteral, icon: string): google.maps.Marker {
    return new google.maps.Marker({
      position: position,
      map: map,
      icon: icon,
    });
  }

  private moveCameraToMarker(position: google.maps.LatLngLiteral): void {
    if (this.map) {
      this.map.setCenter(position);
      this.map.setZoom(13);
    } else {
      console.error('El mapa no está inicializado');
    }
  }

  private removeMarkers(): void {
    if (this.markersOnMap.length > 0) {
      this.markersOnMap.forEach(marker => marker.setMap(null)); // Elimina todos los marcadores del mapa
      this.markersOnMap = []; // Vacía el array de marcadores
    }
  }

}
